import {Link, RouteComponentProps} from '@reach/router';
import {Column} from 'material-table';
import React from 'react';
import {AdminElement} from '../../Components/auth/AdminElement';
import {CreateButton} from '../../Components/Buttons/CreateButton';
import {ExportButton} from '../../Components/Buttons/ExportButton';
import Row from '../../Components/Layout/Row';
import {RowOfButtons} from '../../Components/Layout/RowOfButtons';
import PageTitle from '../../Components/PageTitle/PageTitle';
import {TagsRowRenderer} from '../../Components/Tags/TagsRowRenderer';
import {buildUniversalTagsFilter} from '../../Components/UniversalRListTable/Filters/buildUniversalTagsFilter';
import {DistrictFilter} from '../../Components/UniversalRListTable/Filters/DistrictFilter';
import {DistrictContext} from '../../Components/UniversalRListTable/Helpers/DistrictContext';
import {useDistrictState} from '../../Components/UniversalRListTable/Helpers/useDistrictState';
import {UniversalRListTable} from '../../Components/UniversalRListTable/UniversalRListTable';

/**
 * School's R-list.
 * @param {RouteComponentProps} props
 * @return {JSX.Element}
 * @constructor
 */
export default function SchoolsRList(props: RouteComponentProps) {
  const DC = useDistrictState();

  const apiUriPrefix = '/school/';
  const TagsFilter = buildUniversalTagsFilter('SCHOOL_TAGS_LIST');

  const Columns: Column<any>[] =
    [
      {
        title: '#',
        field: 'id',
        filtering: false,
      },
      {
        title: 'Название краткое',
        field: 'name_short',
        render: (rowData): React.ReactNode =>
          <Link to={`${apiUriPrefix}${rowData.id}`}>{rowData.name_short}</Link>,
      },
      {
        title: 'Название',
        field: 'name_full',
        render: (rowData): React.ReactNode =>
          <Link to={`${apiUriPrefix}${rowData.id}`}>{rowData.name_full}</Link>,
      },
      {
        title: 'Адрес',
        field: 'address',
      },
      {
        title: 'Район',
        field: 'district.name',
        defaultFilter: DC.district,
        filterComponent: DistrictFilter,
      },
      {
        title: 'Телефон',
        field: 'phone_number',
      },
      {
        title: 'Email',
        field: 'email',
      },
      {
        title: 'Метки',
        field: 'tags',
        sorting: false,
        filterComponent: TagsFilter,
        render: TagsRowRenderer,
      },
    ];
  const lastQueryKeyName = 'schoolsReadList';

  return (
    <React.Fragment>
      <PageTitle title={'Организации'}/>
      <RowOfButtons>
        <ExportButton name={lastQueryKeyName}/>
        <AdminElement>
          <CreateButton entity={'school'}/>
        </AdminElement>
      </RowOfButtons>

      <Row>
        <DistrictContext.Provider value={DC}>
          <UniversalRListTable
            columns={Columns}
            action={'SCHOOLS_INDEX'}
            tableName={lastQueryKeyName}
          />
        </DistrictContext.Provider>
      </Row>

    </React.Fragment>
  );
}
